// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__vCmHH","count":"style__count__EEfBD","rightSection":"style__rightSection__DCZ74","button":"style__button__qRNVc"};